<template>

    <!-- 变更成功率统计 -->
    <el-table
            :data="changeTableData"
            :height="height"
            style="width: 100%">
        <el-table-column
                prop="dcnumName"
                label="数据中心"
        >
        </el-table-column>
        <el-table-column
                prop="levelValue"
                label="变更成功率"
                width="100px"
        >
        </el-table-column>
        <el-table-column
                prop="level1Value"
                label="一级变更成功率"
                width="100px">
        </el-table-column>
        <el-table-column
                prop="level2Value"
                label="二级变更成功率"
                width="100px">
        </el-table-column>
        <el-table-column
                prop="level3Value"
                label="三级变更成功率"
                width="100px">
        </el-table-column>
        <el-table-column
                prop="level4Value"
                label="四级变更成功率"
                width="100px">
        </el-table-column>
    </el-table>

</template>

<script>

    import {formatDate} from "element-ui/src/utils/date-util";
    import WorkOrderServer from "@/api/workorder";

    let that;

    export default {
        name: "ticketOnTimeStatistics",

        props: {
            height: {
                type: String,
            },
            dcnumids: {
                type: Array,
            },
            dcnumMap: null,
            searchDate: {
                type: String,
                default() {
                    return formatDate(new Date(), 'yyyy-MM');
                }
            },
        },

        async mounted() {

        },

        data() {
            return {
                changeTableData: [],
            }
        },

        methods: {
            query() {
                let params = {
                    'roomIds': this.dcnumids,
                    'month': this.searchDate,
                }
                WorkOrderServer.workOrder.monthReportChange(params).then(res => {
                    this.changeTableData = [];
                    for (let i = 0; i < that.dcnumids.length; i++) {
                        let lineData = {};
                        lineData.dcnumName = that.dcnumMap.get(that.dcnumids[i] + '');
                        for (let j = 0; j < res.length; j++) {
                            lineData.levelValue = '-';
                            lineData.level1Value = '-';
                            lineData.level2Value = '-';
                            lineData.level3Value = '-';
                            lineData.level4Value = '-';
                            if (that.dcnumids[i] == res[j].roomId) {
                                lineData.levelValue = res[j].closeCount == 0 ? '-' : (res[j].closeCount / res[j].finishCount * 100).toFixed(2) + '%';
                                lineData.level1Value = res[j].level1CloseCount == 0 ? '-' : (res[j].level1CloseCount / res[j].level1FinishCount * 100).toFixed(2) + '%';
                                lineData.level2Value = res[j].level2CloseCount == 0 ? '-' : (res[j].level2CloseCount / res[j].level2FinishCount * 100).toFixed(2) + '%';
                                lineData.level3Value = res[j].level3CloseCount == 0 ? '-' : (res[j].level3CloseCount / res[j].level3FinishCount * 100).toFixed(2) + '%';
                                lineData.level4Value = res[j].level4CloseCount == 0 ? '-' : (res[j].level4CloseCount / res[j].level4FinishCount * 100).toFixed(2) + '%';
                                break;
                            }
                        }
                        that.changeTableData.push(lineData);
                    }
                });
            },

            /**
             * 接单率低于97%的红色字体显示
             * @param row
             * @param column
             * @param rowIndex
             * @param columnIndex
             * @returns {string}
             */
            cellStyle({row, column, rowIndex, columnIndex}) {
                let num = 97;
                if (columnIndex == 1 && row.onTimeValue.substring(0, row.onTimeValue.length - 1) < num) {
                    return 'color: red';
                } else if (columnIndex == 2 && row.onTimeLevel1Value.substring(0, row.onTimeLevel1Value.length - 1) < num) {
                    return 'color: red';
                } else if (columnIndex == 3 && row.onTimeLevel2Value.substring(0, row.onTimeLevel2Value.length - 1) < num) {
                    return 'color: red';
                } else if (columnIndex == 4 && row.onTimeLevel3Value.substring(0, row.onTimeLevel3Value.length - 1) < num) {
                    return 'color: red';
                } else if (columnIndex == 5 && row.onTimeLevel4Value.substring(0, row.onTimeLevel4Value.length - 1) < num) {
                    return 'color: red';
                } else {
                    return '';
                }
            },

        },

        watch: {
            dcnumids: {
                immediate: true,
                handler: function (newVal, oldVal) {
                    if (newVal != null && newVal.length > 0) {
                        this.query();
                    }
                }
            },

            searchDate: {
                handler: function (newVal, oldVal) {
                    if (newVal != null && newVal != '') {
                        this.query();
                    }
                }
            },

        },

        created() {
            that = this;
        }

    }
</script>

<style scoped>

</style>
